import { createPortal } from 'react-dom'
import { motion, AnimatePresence } from 'framer-motion'

export default function Drawer({ open, onClose, title, children }) {
  const root = document.getElementById('drawer-root')
  if (!root) return null

  return createPortal(
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            key="overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            onClick={onClose}
            className="fixed inset-0 bg-black/35 backdrop-blur-[2px] z-40"
          />
          <motion.aside
            key="panel"
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '100%' }}
            transition={{ duration: 0.25, ease: 'easeOut' }}
            className="fixed right-0 top-0 h-screen w-[min(420px,90%)] bg-white shadow-xl z-50 flex flex-col"
            onClick={e => e.stopPropagation()}
          >
            <header className="flex items-center justify-between px-5 h-14 border-b border-gray-200 font-semibold">
              <h3>{title}</h3>
              <button onClick={onClose} className="text-xl leading-none">
                ×
              </button>
            </header>
            <div className="flex-1 overflow-y-auto p-5">{children}</div>
          </motion.aside>
        </>
      )}
    </AnimatePresence>,
    root
  )
}
